import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from 'actions/utils';
import { ICommonResponseObject, ISpeciality } from 'api/types';
import { IReducers } from 'reducers';
import genericReducers from 'reducers/genericReducer';
import { connectReducers } from 'utils';

import { GET_SPECIALITIES_REF } from '../actions';

export type SpecialitiesRefState = ICommonResponseObject<ISpeciality[]>;

const initialState: SpecialitiesRefState = {
  content: [],
  loading: false,
};
const generic = genericReducers<SpecialitiesRefState>();
const specialitiesRef: IReducers<SpecialitiesRefState> = {
  [GET_SPECIALITIES_REF[REQUEST]]: generic.get.request,
  [GET_SPECIALITIES_REF[SUCCESS]]: generic.get.success,
  [GET_SPECIALITIES_REF[FAILURE]]: generic.get.failure,
  [GET_SPECIALITIES_REF[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, specialitiesRef);
